import filesActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';

export default createAsyncRequestReducer(filesActionTypes.FETCH_DATASETS);
